module.exports = __webpack_public_path__ + "assets/img/transparency-4.14ed45e9.svg";